<template>
    <div class="servico">

        <!-- Página: Portas Automáticas -->
        <section id="portas-automaticas" class="servico-section">
            <h2>Montagem e Manutenção de Portas Automáticas</h2>
            <img src="@/assets/images/ffjbporta.jpg" alt="Porta Automática Industrial" class="servico-img" />
      <h2>Soluções para acessos seguros e eficientes, com expertise em automação.</h2>
      <ul class="servico-lista">
        <li><button @click="abrirModal('modal1')">Instalação de portas deslizantes, basculantes e industriais</button></li>
        <li><button @click="abrirModal('modal2')">Reparação de sensores, motores e sistemas de segurança</button></li>
      </ul>
    </section>

    <!-- Modal 1 -->
    <div v-if="modalAberto === 'modal1'" class="modal-overlay">
      <div class="modal-content">
        <h3>Instalação de portas deslizantes, basculantes e industriais</h3>
        <p><strong>Descrição:</strong>  Montagem de portas automáticas com sensores e motores</p>
        <p><strong>Benefício:</strong>  PFacilita acesso e aumenta segurança, ideal para comércios e indústrias.</p>
        <p><strong>Exemplo:</strong> Porta deslizante em loja no Lobito</p>
        <p><strong>Prazo:</strong> Simples (1-2 dias); Complexo (3-5 dias).</p>
        <p><strong>Pagamento:</strong> Simples (completo); Complexo (diagnóstico + parcelado)</p>
        <p><strong>Normas:</strong> EN 13241, ISO 13849</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>

    <!-- Modal 2 -->
    <div v-if="modalAberto === 'modal2'" class="modal-overlay">
      <div class="modal-content">
        <h3>Reparação de sensores, motores e sistemas de segurança</h3>
        <p><strong>Descrição:</strong> : Conserto de falhas em sensores ou motores.</p>
        <p><strong>Benefício:</strong> Garante operação segura e evita falhas de acesso</p>
        <p><strong>Exemplo:</strong>  Reparo de sensor em porta de shopping</p>
        <p><strong>Prazo:</strong> Simples (2-4 horas); Complexo (1-2 dias)</p>
        <p><strong>Pagamento:</strong> Simples (completo); Complexo (diagnóstico + parcelado)</p>
        <p><strong>Normas:</strong>  ISO 13849, CE</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalAberto: null,
    };
  },
  methods: {
    abrirModal(modalId) {
      this.modalAberto = modalId;
    },
    fecharModal() {
      this.modalAberto = null;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.servico {
  padding: 40px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
}

.servico-section {
  margin-bottom: 60px;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.servico-section h1,
h2 {
  text-align: center;
  color: #005580;
  margin-bottom: 20px;
}

.servico-section h1 {
  font-size: 28px;
  border-bottom: 2px solid #005580;
  padding-bottom: 10px;
}

.servico-section h2 {
  font-size: 20px;
  font-weight: normal;
}

.servico-img {
  display: block;
  margin: 0 auto 20px auto;
  width: 50%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.servico-lista {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.servico-lista li button {
  background-color: #005580;
  color: white;
  border: none;
  padding: 12px 18px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  text-align: center;
}

.servico-lista li button:hover {
  background-color: #0077a6;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content h3 {
  margin-top: 0;
  color: #005580;
  margin-bottom: 20px;
  text-align: center;
}

.modal-content p {
  margin: 10px 0;
  line-height: 1.5;
  color: #333;
}

.fechar-btn {
  display: block;
  margin: 20px auto 0 auto;
  background-color: #cc0000;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.fechar-btn:hover {
  background-color: #e60000;
}

@keyframes fadeIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>